export default "__VITE_ASSET__Bd43jGBt__"